import baseHttpService from "core/http/singleton/base";
import {
  getFeedbackDetailUrl,
  getHolidayUrl,
  getListArriveLateDetailUrl,
  getListArriveLateManagerUrl,
  getListArriveLateUrl,
  getListFeedbackManagerUrl,
  getListFeedbackUrl,
  getListRequestLeaveManagerUrl,
  getListRequestLeaveUrl,
  getRequestLeaveDetailUrl,
  getTimeCheckingMonthUrl,
  getTimeCheckingUrl,
} from "./urls";
import { ArriveLateResponse } from "./resTypes";

export const getTimeCheckingAPI = async (params: {
  screenCode: string;
  month: string;
  year: string;
}): Promise<any> => {
  const { screenCode, month, year } = params;
  const res = await baseHttpService.get<any>(getTimeCheckingUrl(screenCode), {
    month,
    year,
  });
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListArriveLateAPI = async (params: {
  screenCode: string;
  month: number;
  year: number;
  limit?: number;
  offset?: number;
  sort?: string;
}): Promise<any> => {
  const { screenCode, ...queryParams } = params;
  const res = await baseHttpService.get<ArriveLateResponse[]>(
    getListArriveLateUrl(screenCode),
    queryParams
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListArriveLateManagerAPI = async (params: {
  screenCode: string;
  month: number;
  year: number;
  limit?: number;
  offset?: number;
  sort?: string;
}): Promise<any> => {
  const { screenCode, ...queryParams } = params;
  const res = await baseHttpService.get<ArriveLateResponse[]>(
    getListArriveLateManagerUrl(screenCode),
    queryParams
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListArriveLateDetailAPI = async (params: {
  screenCode: string;
  id?: string;
}): Promise<any> => {
  const { screenCode, id } = params;
  const res = await baseHttpService.get<ArriveLateResponse[]>(
    getListArriveLateDetailUrl(screenCode, id)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListRequestLeaveManagerAPI = async (params: {
  screenCode: string;
  month: number;
  year: number;
  limit?: number;
  offset?: number;
  sort?: string;
}): Promise<any> => {
  const { screenCode, ...queryParams } = params;
  const res = await baseHttpService.get<ArriveLateResponse[]>(
    getListRequestLeaveManagerUrl(screenCode),
    queryParams
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListRequestLeaveAPI = async (params: {
  screenCode: string;
  month: number;
  year: number;
  limit?: number;
  offset?: number;
  sort?: string;
}): Promise<any> => {
  const { screenCode, ...queryParams } = params;
  const res = await baseHttpService.get<ArriveLateResponse[]>(
    getListRequestLeaveUrl(screenCode),
    queryParams
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getRequestLeaveDetailAPI = async (id: string): Promise<any> => {
  const res = await baseHttpService.get<any>(getRequestLeaveDetailUrl(id));
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getHolidayAPI = async (
  month: number,
  year: number
): Promise<any> => {
  const res = await baseHttpService.get<any>(getHolidayUrl(month, year));
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getTimeCheckingMonthAPI = async (params: {
  screenCode: string;
  month: string;
  year: string;
}): Promise<any> => {
  const { screenCode, month, year } = params;
  const res = await baseHttpService.get<any>(
    getTimeCheckingMonthUrl(screenCode),
    {
      month,
      year,
    }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListFeedbackAPI = async (params: {
  screenCode: string;
  month: number;
  year: number;
  limit?: number;
  offset?: number;
  sort?: string;
}): Promise<any> => {
  const { screenCode, ...queryParams } = params;
  const res = await baseHttpService.get<ArriveLateResponse[]>(
    getListFeedbackUrl(screenCode),
    queryParams
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListFeedbackManagerAPI = async (params: {
  screenCode: string;
  month: number;
  year: number;
  limit?: number;
  offset?: number;
  sort?: string;
}): Promise<any> => {
  const { screenCode, ...queryParams } = params;
  const res = await baseHttpService.get<ArriveLateResponse[]>(
    getListFeedbackManagerUrl(screenCode),
    queryParams
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getFeedbackDetailAPI = async (params: {
  screenCode: string;
  id?: string;
}): Promise<any> => {
  const { screenCode, id } = params;
  const res = await baseHttpService.get<ArriveLateResponse[]>(
    getFeedbackDetailUrl(screenCode, id)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
